const compareTwoNumbers = (a: number, b: number) => {
    return a - b;
}
export default compareTwoNumbers;